import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@bbj/components";

@Component({
  selector: "app-singout",
  templateUrl: "./singout.component.html",
  styleUrls: ["./singout.component.scss"],
  standalone: false,
})
export default class SingoutComponent {
  authService = inject(AuthService);
  router = inject(Router);
  private activeRoute = inject(ActivatedRoute);

  ngOnInit(): void {
    if (this.activeRoute.routeConfig.path === "logout") {
      this.authService.logout();
    }
  }

  login(): void {
    this.router.navigate(["/"]);
  }
}
